
define(
	'TrackingSO.EntryPoint'
,   [
		'TrackingSO.Checkout.View',
		'Profile.Model'
	]
,   function (
		TrackingSOCheckoutView,
		ProfileModel
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var environmentComponent = container.getComponent('Environment');
			var profile = ProfileModel.getInstance();
			var customerId = profile.get('internalid');
			var trackingSOConfiguration = {};
			if (environmentComponent) {
				trackingSOConfiguration = environmentComponent.getConfig('TrackingSO');
			}
			var enableTrackingSO = trackingSOConfiguration.enableTrackingSOAllCustomers || (trackingSOConfiguration.testCustomer == customerId);
			
			if(enableTrackingSO){
				var checkout = container.getComponent('Checkout');
				if (checkout) {
					checkout.addModuleToStep({
						step_url: 'opc',
						module: {
							id: 'TrackingSO.Checkout.View',
							index: 21,
							classname: 'TrackingSO.Checkout.View',
							options: {
								trackingSOConfiguration: trackingSOConfiguration
							}
						}
					});
				}
			}
		}
	};
});
